module.exports = __webpack_public_path__ + "img/mlh_honor_3.0967db67.png";